module.exports = __webpack_public_path__ + "img/carrusel_03.d210ebd4.jpg";